export default {
  titles: {
    pickup: 'Para levar',
    delivery: 'Entrega',
  },
  buttons: {
    confirm: 'Confirmar',
  },
};
